module.exports = __webpack_public_path__ + "img/2.10682d1b.jpg";